module.exports = __webpack_public_path__ + "img/palestine.f8857041.png";